// extracted by mini-css-extract-plugin
export default {"FooterWrapperNav":"FooterWrapperNav_FooterWrapperNav__DRdiu"};